/// <reference path="../../typings/index.d.ts" />

import {DataStore} from './DataStore';
import {Popup} from './Popup';
import { showKopiAktiviteter } from './GridKopiAktiviteter';
import { Utils } from '../Utils';
import * as _ from "underscore";
import * as moment from "moment";
import { KopiereAktiviteterTilPlan } from './KopiereAktiviteterTilPlan';
import { EditAktivitet, newEmptyAktivitet } from './EditAktivitet';
import { AntallCab } from "./AntallCab";
import * as events from "../Eventbus/Eventbus";

export function showAktiviteter(container, options) {
    new GridAktiviteter(container, options);
}

export class GridAktiviteter {
    name: string = "GridAktiviteter";
    selectedAktivitetGrid: any;
    planStart: Date = null;
    planEnd: Date = null;
    forfallsDager: number = 17;
    form: DevExpress.ui.dxForm;
    planId: number;
    planNavn: string;
    grid: DevExpress.ui.dxDataGrid;
    brukere: any;
    rndId: string;

    constructor(container, options) {
        var planId: number = options.data.id;
        this.planNavn = options.data.navn;
        this.planId = planId;
        this.rndId = Utils.rndId();
        var myself: GridAktiviteter = this;
        $.getJSON("/Data/Bruker", (data) => {
            myself.brukere = data;
        });

        if (container != null) {
            container.addClass("internal-grid-container p10");
            var html = '<table class="internal-grid-caption blar1"><tr>';
            html += '<td><i class="fa fa-tasks"></i>&nbsp;Hoved Aktiviteter for ' + options.data.navn + ' <span id="cntHoved' + planId + '"/></td>';
            html += '<td class="pl20 mt--4"><div id="addAktivitet' + this.rndId + '"></div></td>';
            html += '<td class="pl20 mt--4"><div id="btnAntall' + this.rndId + '" class="cab-color"></div></td>';
            //html += '<td class="pl20 mt--4"><div id="btnAntallProdusert' + planId + '" class="cab-color"></div></td>';
            html += '<td class="pl20 mt--4"><div id="btnKopiAkt2Plan' + this.rndId + '" class="kop-color"></div></td>';
            html += '<td class="pl20 mt--4"><div id="btnExport' + this.rndId + '"></div></td>';
            html += '</tr></table>';
            container.append(html);
            Utils.wait();
            this.refreshAntall();

            $.getJSON("/Data/HovedAktivitetForPlan", { planId: planId }, function (data) {
                //$("#cntHoved" + planId).text(' (Antall: ' + data.length + ', kontrollert: ' + kontrollert(data) + ')');
                var gridDiv = $('<div>')
                    .addClass("internal-grid akt akt" + planId)
                    .dxDataGrid({
                        dataSource: data,
                        rowAlternationEnabled: true,
                        columnAutoWidth: false,
                        //width: 1000,
                        allowColumnReordering: true,
                        allowColumnResizing: true,
                        columnChooser: {
                            enabled: true
                        },
                        columnFixing: {
                            enabled: true
                        },
                        filterRow: {
                            visible: true,
                            applyFilter: "auto"
                        },
                        selection: {
                            mode: "single"
                        },
                        headerFilter: {
                            visible: true
                        },
                        scrolling: {
                            //mode: "virtual",
                            showScrollbar: "always",
                            useNative: true
                        },
                        "export": {
                            enabled: true,
                            excelFilterEnabled: false,
                            fileName: "Eksport_" + myself.planNavn,
                            proxyUrl: "/Home/Proxy"
                        },
                        noDataText: "Ingen data",
                        showBorders: true,
                        paging: {
                            pageSize: 20,
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [20, 50, 100],
                            showInfo: true
                        },
                        onContentReady: (e) => {
                            if (!e.element.find("#clearSearch_" + myself.rndId).length) {
                                const gridHeader = e.element.find('.dx-datagrid-header-panel .dx-toolbar .dx-toolbar-items-container');
                                gridHeader.append('<div id="clearSearch_' + myself.rndId + '" style="margin: 2px;" />');
                                $("#clearSearch_" + myself.rndId).dxButton({
                                    text: "Nulstille søk", icon: "clear", width: 110, height: 26,
                                    onClick: () => {
                                        myself.grid.clearFilter();
                                    }
                                });
                            }
                            if (!e.element.find("#refresh_" + myself.rndId).length) {
                                const gridHeader = e.element.find('.dx-datagrid-header-panel .dx-toolbar .dx-toolbar-items-container');
                                gridHeader.append('<div id="refresh_' + myself.rndId + '" style="margin: 2px;" />');
                                $("#refresh_" + myself.rndId).dxButton({
                                    text: "Oppdater", icon: "refresh", width: 100, height: 26,
                                    onClick: () => {
                                        myself.refreshGrid();
                                    }
                                });
                            }
                        },
                        onRowClick: (e) => {
                            e.jQueryEvent.stopPropagation();
                            var component = e.component, prevClickTime = component.lastClickTime;
                            component.lastClickTime = new Date();
                            var isExpanded = e.component.isRowExpanded(e.key);
                            if (prevClickTime && !isExpanded && (component.lastClickTime - prevClickTime < 300)) {
                                new EditAktivitet(e.data, planId, () => myself.refreshGrid());
                            }
                        },
                        onCellPrepared: (e: any) => {
                            if (e.rowType === "data" && e.column.command === "expand") {
                                if (e.data.hasKopiAktivitet) {
                                    e.cellElement.addClass("has-children");
                                }
                            }
                        },
                        columns: [
                            {
                                dataField: 'id',
                                caption: 'Id',
                                width: 50,
                                fixed: true
                            },
                            {
                                dataField: 'aktId',
                                caption: 'AktId',
                                width: 60,
                                fixed: true,
                            },
                            {
                                dataField: 'kontrollertDato',
                                caption: 'Kontrollert',
                                width: 80,
                                dataType: 'boolean',
                                calculateCellValue(rowData: any): any {
                                    return rowData.kontrollertDato != null;
                                },
                                fixed: true
                            },
                            {
                                dataField: 'erBatchJob',
                                caption: 'Batch',
                                width: 60,
                                dataType: 'boolean',
                                fixed: true
                            },
                            {
                                caption: 'Navn',
                                dataField: 'aktivitetsItem.navn',
                                width: 300,
                                fixed: true
                            }, {
                                dataField: 'dato',
                                caption: 'Produksjon',
                                dataType: 'date',
                                width: 70,
                                fixed: true
                            }, {
                                dataField: 'printFil',
                                caption: 'PrintFil',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'printFilOverfort',
                                caption: 'Overført',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'distribusjon',
                                caption: 'Distribusjon',
                                dataType: 'date',
                                width: 70
                            }, {
                                dataField: 'forfall',
                                caption: 'Forfall',
                                dataType: 'date',
                                width: 70,
                                calculateCellValue(rowData:any) {
                                    return Utils.fmtDateStr(rowData.forfall);
                                },
                            }, {
                                caption: 'Kontrollert',
                                dataField: 'kontrollertDato',
                                dataType: 'date',
                                width: 70
                            }, {
                                caption: 'Type',
                                dataField: 'ordreType.beskrivelse',
                                width: 100
                            }, {
                                caption: 'Prosess',
                                dataField: 'aktivitetsItem.prosess.navn',
                                width: 70
                            }, {
                                dataField: 'produksjonsType.navn',
                                caption: 'Produksjonstype',
                                width: 100
                            }, {
                                dataField: 'fakturaGruppe.navn',
                                caption: 'FakturaGruppe',
                                width: 130
                            }, {
                                dataField: 'cabOrderNr',
                                caption: 'Ordre',
                                width: 70
                            }, {
                                dataField: 'cabBatchId',
                                caption: 'Batch',
                                width: 70
                            },  {
                                dataField: 'antallPlanlagt',
                                caption: 'Priv. planl.',
                                width: 80
                            }, {
                                dataField: 'antallProdusert',
                                caption: 'Priv. prod.',
                                width: 80
                            }, {
                                dataField: 'antalPlanlagtNaering',
                                caption: 'Nær. planl.',
                                width: 80
                            }, {
                                dataField: 'antalProdusertNaering',
                                caption: 'Nær. prod.',
                                width: 80
                            },{
                                dataField: 'merknader',
                                caption: 'Merknader',
                                width: 150
                            },{
                                width: 100,
                                alignment: 'center',
                                cellTemplate: function (container, options) {
                                    if (!options.data.godkjentDato) {
                                        $('<a/>').addClass('dx-link')
                                            .text('Endre')
                                            .on('dxclick', function () {
                                                new EditAktivitet(options.data, planId, () => myself.refreshGrid());
                                            })
                                            .appendTo(container);
                                    } else if (options.data.utgaar) {
                                        $('<div>').text("Utgaar").appendTo(container);
                                    } else {
                                        $('<a/>').addClass('dx-link')
                                            .text('Endringsordre')
                                            .on('dxclick', function () {
                                                new EditAktivitet(options.data, planId, () => myself.refreshGrid());
                                            })
                                            .appendTo(container);
                                    }
                                }
                            }
                        ],
                        onRowPrepared: (info: any) => Utils.rowPrepare(info),
                        masterDetail: {
                            enabled: true,
                            template: (container, options) => {
                                showKopiAktiviteter(container, options, myself);
                            }
                        }
                    });
                myself.grid = gridDiv.dxDataGrid("instance");
                myself.selectedAktivitetGrid = this.grid;

                $("#addAktivitet" + myself.rndId).dxButton({
                    text: "Ny hovedaktivitet...",
                    icon: 'add',
                    type: "default",
                    onClick: () => new EditAktivitet(null, planId, () => myself.refreshGrid())
                });

                $("#btnAntall" + myself.rndId).dxButton({
                    text: "Antall fra CAB...",
                    icon: 'download',
                    type: "default",
                    onClick: () => new AntallCab(myself.planId, () => myself.refreshGrid())
                });
                //$("#btnAntallProdusert" + planId).dxButton({
                //    text: "Antall produsert fra CAB...",
                //    icon: 'download',
                //    type: "default",
                //    onClick: () => alert('Har hentet antall produsert')
                //});
                $("#btnKopiAkt2Plan" + myself.rndId).dxButton({
                    text: "Kopiere aktiviteter til plan",
                    icon: 'pulldown',
                    type: "default",
                    onClick: () => new KopiereAktiviteterTilPlan(planId, myself.planNavn, () => myself.refreshGrid())
                });
                $("#btnExport" + myself.rndId).dxButton({
                    text: "Eksport til Excel",
                    icon: 'export',
                    type: "default",
                    onClick: () => myself.grid.exportToExcel(false)
                });
                gridDiv.appendTo(container);
                Utils.finished();
            });
        }
    }

    refreshAntall() {
        var self: GridAktiviteter = this;
        $.getJSON("/Data/PlanAktivitetCount", { planId:  self.planId }, function (data) {
            $("#cntHoved" +  self.planId).text(' (Antall: ' + data.antallAktiviteter + ', kontrollert: ' + data.antallKontrollert + ')');
        });
    }

    refreshGrid() {
        var self: GridAktiviteter = this;
        $.getJSON("/Data/HovedAktivitetForPlan", { planId: this.planId }, (data) => {
            self.grid.option("dataSource", data);
            self.grid.refresh();
            self.refreshAntall();
        });
    }

    lagreAktivitet(aktivitet: AktivitetTemplate) {
        //Fix dates for C#
        Utils.fixDates(aktivitet);

        //debugger;
        var self = this;
        console.log(aktivitet);

        $.post("/Data/Aktivitet", { data: aktivitet, endringsAktivitetId: aktivitet.endringsAktivitetId })
            .done((success) => {
                DevExpress.ui.notify("Aktivitet er lagret !", "success", 2000);
                self.refreshGrid();
                //self.popup.hide();
            })
            .fail((xhr, textStatus, errorThrown) => {
                DevExpress.ui.notify("Aktivitet er ikke lagret !", "error", 2000);
            });
    }

    noTime(dato: Date): any {
        return moment(dato).clone().hour(0).minute(0).second(0).millisecond(0)
    }

    getBruker(nr: number): string {
        for (let i = 0; i < this.brukere.length; i++) {
            if (this.brukere[i].id == nr)
                return this.brukere[i].navn;
        }
        return "";
    }
}

export function kontrollert(data): string {
    let cnt: number = 0;
    data.forEach((itm) => {
        if (itm.kontrollertDato != null) {
            cnt++;
            if (itm.hovedAktivitetId == -1) {
                var cntChld: number = kontrollertChildren(itm.id, data);
                cnt += cntChld;
            }
        }
    });
    return cnt.toString();
}

export function kontrollertChildren(hovedId: number, data): number {
    let cnt: number = 0;
    data.forEach((itm) => {
        if (itm.hovedAktivitetId == hovedId && itm.kontrollertDato != null) {
            cnt++;
        }
    });
    return cnt;
}

export interface AktivitetTemplate {
    id: number,
    aktId: string,
    dato: Date,
    merknader: string,
    priority: number,
    utgaar: boolean,
    erBatchJob: boolean,
    hovedAktivitetId: number,
    produksjonsTypeId: number,
    erstattetAv: number,
    endringsAktivitetId: number,
    ordreTypeId: number,
    aktivitetsItemId: number,
    fakturaGruppeId: number,
    orderId: number,
    antallPlanlagt: number,
    antallProdusert: number,
    antalPlanlagtNaering: number,
    antalProdusertNaering: number,
    forfall: Date,
    printFil: Date,
    printFilOverfort: Date,
    distribusjon: Date,
    levert: Date,
    opprettetAv: number,
    opprettetDato: Date,
    sistEndretAv: number,
    sistEndretDato: Date,
    kontrollertAv: number,
    kontrollertDato: Date,
    godKjenttAv: number,
    godKjentDato: Date,
    kontrollertAvDrift: number,
    kontrollertDatoDrift: Date,
    planId: number,
    hasKopiAktivitet: boolean,
    aktivitetsItem: any,
    cabOrderNr: string,
    cabBatchId: string,
    starttidspunkt: string
};


// WEBPACK FOOTER //
// ./TS/Plan/GridAktiviteter.ts